var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$isScreenPortrait())?_c('pages-core-app-bar'):_vm._e(),_c('pages-core-view'),_c('pages-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }